import * as Yup from "yup";

export const validationSchema = (withCompanySelect: boolean, isCreate: boolean) =>
  Yup.object({
    name: Yup.string().required("Please fill out this field."),
    email: isCreate
      ? Yup.string().email("Invalid email address").required("Please fill out this field.")
      : Yup.string().email("Invalid email address").notRequired(),
    phone: Yup.string().min(6, "Please fill out this field.").required("Please fill out this field."),
    position: Yup.string(),
    company: withCompanySelect ? Yup.string().required("Please choose an option.") : Yup.string().notRequired(),
  });
